import { Injectable } from '@angular/core';
import { ConstantePage } from '../constants/constante-page';
import {CnafUserService, CnafAtTagService, PageInfo, ClickInfo } from '@cnaf/ng-cnaf-commons';

@Injectable({
  providedIn: 'root'
})
export class TagWaService {  

  constructor(
    private readonly cnafUserService: CnafUserService,
    private readonly cnafAtTagService: CnafAtTagService
  ) {} 
  
  /**
   * Methode pour réaliser le marquage Web Analytic d'une page
   * 
   * @param pageName 
   * @param chapter3Page 
   */
  tagPage(pageName : string, chapter3Page: string) {
    const site = this.getCustomVars();

    const pageData: PageInfo = {
      name: pageName,
      //Variables communes à toutes les pages
      level2 : ConstantePage.STATS_LEVEL2,
      chapter1 : ConstantePage.STATS_CHAPTER1,
      chapter2 : ConstantePage.STATS_CHAPTER2,      
      //Variable chapterPage varie selon les pages
      chapter3 : chapter3Page,
      //customVars communes à toutes les pages
      customVars: { site }
    };
    this.cnafAtTagService.pageSend(pageData);
  }
  
  /**
   * Methode pour réaliser le marquage Web Analytic d'un clic (souvent pour une popup)
   * 
   * @param clicName 
   * @param chapter3Page 
   */
  tagClic(clicName: string, chapter3Page: string) {
    const clic: ClickInfo = {
      name: clicName,
      level2: '12',
      chapter1 : ConstantePage.STATS_CHAPTER1_CLIC_INFOBULLE,
      chapter2 : ConstantePage.STATS_CHAPTER2,
      chapter3 : chapter3Page,
      type: 'action',
      event: event as MouseEvent,
    };
    this.cnafAtTagService.click(clic);
  }

  /**
  * C'est pas top mais pour le moment c'est comme ça
  *  :( 
  */
  getCustomVars() {
    // Todo faire mieux
    const codeOrga = this.cnafUserService.codeOrga;
    const matricule = this.cnafUserService.matricule;
    const dateEnvCaffr = this.cnafUserService.dateEnvCaffr;
    let custVars1 = 2;
    const custVars2 = 14;
    const custVars8 = codeOrga;

    // si l'usager est authentifié on modifie la valeur de custVars1
    if (dateEnvCaffr !== undefined) {
      if (matricule !== undefined && matricule !== '' && codeOrga !== undefined && codeOrga !== '' ) {
        custVars1 = 1;
        let idFoyer = this.cnafUserService.idFoyer;
        if(idFoyer===undefined) {
          idFoyer='';
        }
        return { 1:custVars1, 2:custVars2, 8:custVars8, 35:matricule, 36:idFoyer };
      }
    }

    return { 1:custVars1, 2:custVars2, 8:custVars8 };
  }
}

